module.exports = __webpack_public_path__ + "img/9788949120980.61fe3d1a.jpg";